import script from "./ProgrammeOnline24June.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgrammeOnline24June.vue?vue&type=script&setup=true&lang=js"

import "./ProgrammeOnline24June.vue?vue&type=style&index=0&id=cb9be5ca&lang=css"

const __exports__ = script;

export default __exports__